export * from './src/bookings-availability-v2-time-slot-event-time-slots.universal.js';
